'use client';

import H2 from '@/components/typography/h2';
import P from '@/components/typography/p';
import SubscriptionInput from '@/components/ui/subscription-input';
import { useTranslation } from 'react-i18next';

export default function ContactCard() {
    const { t } = useTranslation();

    return (
        <div className="">
            <div className="mt-12 flex flex-col items-center pt-2 pb-20 lg:mt-16 lg:pb-40">
                <div className="bg-lightyellow flex min-h-[23.5rem] w-[20.87rem] transform-[rotate(1.373deg)] flex-col rounded-lg lg:min-h-[441px] lg:w-[717px] lg:transform-[rotate(-1.4deg)]">
                    <div className="w-full border-b border-black">
                        <div className="px-5 py-7 pb-3 lg:px-16 lg:pt-10 lg:pb-5">
                            <H2 className="uppercase italic">
                                {t('contactCard.title')}
                                <br className="hidden lg:block" />{' '}
                                {t('contactCard.subtitle')}
                            </H2>
                        </div>
                    </div>
                    <div className="flex flex-col gap-6 px-5 pt-7 pb-5 lg:gap-8 lg:px-16 lg:pt-10 lg:pb-5">
                        <P>{t('contactCard.description')}</P>
                        <div className="flex">
                            <SubscriptionInput className="w-full" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
